import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Userback from '@userback/widget';
import { FEATURE_FLAGS, THIRD_PARTY_CONFIG } from '../config/env';

let userbackInstance = null;
let initializingPromise = null;

const getUserData = (user) => {
  if (!user) return null;

  const id = String(user.id || user.email || user.username || '').trim();
  if (!id) return null;

  return {
    id,
    name: user.full_name || user.name || user.username || '',
    email: user.email || '',
  };
};

const buildOptions = (userData) => ({
  user_data: {
    id: userData.id,
    info: {
      name: userData.name,
      email: userData.email,
    },
  },
});

export default function UserbackWidgetInitializer() {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (!isAuthenticated) return;
    if (!FEATURE_FLAGS.ENABLE_USERBACK) return;

    const token = THIRD_PARTY_CONFIG.USERBACK_TOKEN;
    if (!token) {
      if (import.meta.env.DEV) {
        console.warn('Userback is enabled, but VITE_USERBACK_TOKEN is missing.');
      }
      return;
    }

    const userData = getUserData(user);
    if (!userData) return;

    const initialize = async () => {
      try {
        if (!initializingPromise) {
          initializingPromise = Userback(token, buildOptions(userData));
        }

        if (!userbackInstance) {
          userbackInstance = await initializingPromise;
        } else if (typeof userbackInstance.identify === 'function') {
          userbackInstance.identify(userData.id, {
            name: userData.name,
            email: userData.email,
          });
        }
      } catch (error) {
        console.error('Failed to initialize Userback widget:', error);
        initializingPromise = null;
        userbackInstance = null;
      }
    };

    initialize();
  }, [isAuthenticated, user]);

  return null;
}
